import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Journey } from './journey.interface';
import { JourneyService } from './journey.service';
const service = new JourneyService();

export interface JourneyState {
   journeys: Array<Journey>;
}

const JourneyStore: Module<JourneyState, StoreState> = {
   namespaced: true,
   state: {
      journeys: [],
   },
   getters: {},
   mutations: {
      SET_JOURNEYS(state, journeys: Array<Journey>) {
         state.journeys = journeys;
      },
   },
   actions: {
      async getJourneys(context, query: LocationQuery) {
         const response = await service.getJourneys(query);
         context.commit('SET_JOURNEYS', response.data);
         return response;
      },
      async getJourneyTemplate(context, journey_Id: number) {
         const response = await service.getJourneyTemplate(journey_Id);
         return response.data;
      },
      async getJourney(context, payload: { id: number; query: LocationQuery }) {
         const response = await service.getJourney(payload.id, payload.query);
         return response.data;
      },
      async searchJourneys(context, query: LocationQuery) {
         return await service.getJourneys({ ...query, per_page: '30', page: '1' }).then((response) => response.data);
      },
      async putJourney(context, id: number) {
         return await service.putJourney(id).then((response) => response.data);
      },
   },
};

export default JourneyStore;
